import chroma from 'chroma-js';

export const getBarStyle = (active, fill, fillActive, maskId) => {
  return {
    fill: active ? fillActive : fill,
    mask: maskId ? `url(#${maskId})` : null,
  };
};

export const getColumnStyle = (active, fill, fillActive) => {
  return {
    fill: active ? fillActive : fill,
  };
};

export const getFill = (fill) => {
  return fill ? chroma(fill).css() : null;
};

export const getFillActive = (fill, brightness = 0.8) => {
  return fill ? chroma(fill).brighter(brightness).css() : null;
};
